import { Headers } from '@angular/http';
import { Component, Renderer } from '@angular/core';
import { MenuController, NavController, Select } from 'ionic-angular';
//Providers
import { UtilProvider } from '../../providers/util-provider';
import { ExpositorProvider } from '../../providers/expositor-provider';
import { ConfigProvider } from '../../providers/config-provider';
import { AuthProvider } from './../../providers/auth-provider';
//Components
import { CustomAlert } from '../../components/custom-alert.component';
//Pages
import { ExpositorPage } from '../expositor/expositor';
//Models
import { Expositor } from '../../models/expositor/expositor.model';
import { Congresso } from '../../models/congresso.model';
import { ExpositoresPorTipo } from '../../models/expositor/expositores-tipo.model';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { User } from '../../models/user.model';

@Component({
  selector: 'page-expositores',
  templateUrl: 'expositores.html'
})
export class ExpositoresPage {

  public loaded: boolean;
  public expositores: Array<ExpositoresPorTipo>
  public expositoresFiltrados: Array<ExpositoresPorTipo>;
  public congresso: Congresso;
  private searchTermExpositor: string = "";
  private count: number;

  public user: User;

  constructor(public navCtrl: NavController,
    private menuCtrl: MenuController,
    private alert: CustomAlert,
    private renderer: Renderer,
    private inAppBrowser: InAppBrowser,
    public expositorProvider: ExpositorProvider,
    public configProvider: ConfigProvider,
    public authProvider: AuthProvider,
    public utilProvider: UtilProvider) {
    this.congresso = this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
    this.user = JSON.parse(localStorage.getItem('user')) as User;
  }

  ionViewDidEnter(){
    this.menuCtrl.swipeEnable(true, 'right');
  }

  ionViewDidLoad() {
    this.get();
    this.user = JSON.parse(localStorage.getItem('user')) as User;
    this.utilProvider.searchInFocus = false;
    this.utilProvider.searchTerm = "";

    if (this.expositoresFiltrados)
      this.searchTermExpositoresByTerm(this.searchTermExpositor);
  }


  get() {
    let self = this;
    if (self.utilProvider.isConnected(true)) {
      setTimeout(() => {
        this.expositorProvider.getExpositoresGroupedByType(self.congresso.Ano, false, false)
          .then(res => {

            self.expositores = [];

            let organizacao = res.filter(function (x) { return x.Tipo == 'Organização' });            
            if (organizacao[0])
              self.expositores.push(organizacao[0]);

            let patrocinioMaster = res.filter(function (x) { return x.Tipo == 'Patrocínio' });
            if(patrocinioMaster[0]) {
              patrocinioMaster[0].Tipo = 'Patrocinador Master';
              self.expositores.push(patrocinioMaster[0]);
            }

            let expositores = res.filter(function (x) { return x.Tipo == 'Apoio' });
            if(expositores[0]) {
              expositores[0].Tipo = 'Expositores';
              self.expositores.push(expositores[0]);
            }

            self.expositores.forEach(x => {
              x.Expositores.filter(e => {
                e.Logo = this.configProvider.url.Cientifico + e.Logo;
                e.ListLogo = this.configProvider.url.Cientifico + e.ListLogo
                e.Emblema = this.configProvider.url.Cientifico + e.Emblema;
                x.ExpositoresFiltrados = x.Expositores;
              })
            });

            self.expositoresFiltrados = self.expositores.slice(0, this.count)

            self.loaded = true;
            self.setLocalStorage();
          })
          .catch(response => {
            let err = response;
            if (err) {
              self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
            }
          });
      }, 0);
    }
    else {
      self.getFromStorage();
    }
  }

  setLocalStorage() {
    let expositores = this.expositores;
    localStorage.setItem('expositores', expositores ? JSON.stringify(expositores) : '');
  }

  getFromStorage() {
    let self = this;

    if (localStorage.getItem('expositores')) {
      self.expositores = JSON.parse(localStorage.getItem('expositores')).sort(function (a, b) {
        return a.Tipo.localeCompare(b.Tipo);
      });

      self.expositores.forEach(x => {
        x.Expositores.filter(e => {
          e.Logo = this.configProvider.url.Cientifico + e.Logo;
          e.ListLogo = this.configProvider.url.Cientifico + e.ListLogo
          e.Emblema = this.configProvider.url.Cientifico + e.Emblema;
        })
        x.ExpositoresFiltrados = x.Expositores;
      });
      self.expositoresFiltrados = self.expositores.slice(0, this.count);
      self.loaded = true;
    }
  }

  searchTermExpositoresByTerm(ev: any) {

    this.expositoresFiltrados = this.expositores;

    let val = ev;
    if (ev.target)
      val = ev.target.value;

    if (val && val.trim() && this.expositoresFiltrados.length != 0) {

      this.expositoresFiltrados.filter((g) => {
        g.ExpositoresFiltrados = g.Expositores.filter((e) => {
          return (this.utilProvider.prepareSearch(e.Nome).includes(this.utilProvider.prepareSearch(val)));
        });
      });
    }
    else {
      this.expositoresFiltrados.filter((g) => {
        g.ExpositoresFiltrados = g.Expositores;
      });
    }

    this.count = this.expositoresFiltrados.length;

    if (ev.target)
      this.renderer.invokeElementMethod(ev.target, 'blur');
  }

  openExpositorPage(e: Expositor) {

    var self = this;

    self.checkLoggedUser();

    if (e.Stand && e.Stand.Prescritor && !self.authProvider.isAuthorized(true)) {
      self.authProvider.isAuthorized();
    }
    else if (e.Stand && e.Stand.Prescritor && self.authProvider.isAuthorized(true) && !self.user.Prescritor) {
      self.alert.showAlert('Aviso', 'Stand disponível apenas para prescritores.');
    }
    else {
      self.navCtrl.push(ExpositorPage, {
        expositor: e,
      });
    }
  }

  openUrl(url, inNativeBrowser) {
    if (this.utilProvider.isNullOrEmpty(url) || url == '#')
      return false;

    if (inNativeBrowser) {

      const browser = this.inAppBrowser.create(url, '_blank', "location=yes,toolbar=yes,hidden=no");
      browser.show();

    } else {
      const browser = this.inAppBrowser.create(url, '_blank', "location=yes,toolbar=yes,hidden=no");
      browser.show();
    }
  }

  openSorteio(e: Expositor) {

    if (this.getValidSorteio(e))
      this.openUrl(e.LinkSorteio, false);
    else {
      if (!this.authProvider.isAuthorized(true) && e.CategoriasSorteio.length) {
        var categories = e.CategoriasSorteio.map(x => x.Description).toString().replace(/,/g, ', ');
        this.alert.showAlert('Aviso', 'Sorteio disponível para membros da(s) categoria(s) <b>' + categories + '</b>. Faça o login para participar.');
      }
    }
  }

  getValidSorteio(e: Expositor) {
    var haslink = e.LinkSorteio;
    var hasCategories = e.CategoriasSorteio.length > 0;
    var self = this;

    self.checkLoggedUser();

    //logado
    if (hasCategories && !!haslink && this.authProvider.isAuthorized(true) && self.user) {
      return e.CategoriasSorteio.some(x => x.CategoryId == self.user.CategoriaId && self.user.TipoAssociacaoId == x.TipoAssociacaoId);
    }

    return !!haslink && !hasCategories;
  }

  hasResult() {
    return this.expositoresFiltrados && this.expositoresFiltrados.some(x => x.ExpositoresFiltrados && x.ExpositoresFiltrados.length > 0);
  }

  checkLoggedUser() {
    let self = this;
    if (self.authProvider.isAuthorized(true) && !self.user) {
      self.user = JSON.parse(localStorage.getItem('user')) as User;
    }
    else if (!self.authProvider.isAuthorized(true) && self.user) {
      self.user = undefined;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/expositores/expositores.ts